import { Monitor, Moon, Sun } from "lucide-react";
import { useAppContext } from "../../hooks/useAppContext";

export const ThemeSelector = () => {
    const { theme, setTheme } = useAppContext();
    return (<div className="relative group">
        <button className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
            {theme === 'light' && <Sun className="w-5 h-5" />}
            {theme === 'dark' && <Moon className="w-5 h-5" />}
            {theme === 'system' && <Monitor className="w-5 h-5" />}
        </button>
        <div className="absolute right-0 mt-2 py-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none group-hover:pointer-events-auto">
            <button
                onClick={() => setTheme('light')}
                className="flex items-center w-full px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
            >
                <Sun className="w-4 h-4 mr-2" />
                Clair
            </button>
            <button
                onClick={() => setTheme('dark')}
                className="flex items-center w-full px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
            >
                <Moon className="w-4 h-4 mr-2" />
                Sombre
            </button>
            <button
                onClick={() => setTheme('system')}
                className="flex items-center w-full px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
            >
                <Monitor className="w-4 h-4 mr-2" />
                Système
            </button>
        </div>
    </div>);
}